<template>
  <DeviceIcon v-if="type === 'icon'"
    :gatewayConnected="gateway.connectionStatus"
    :connection="connection"
  />
  <span v-else-if="type === 'label'">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { qx_Sensor } from '@/graphql/types';
import { useSensorStatus } from '@/models/sensor/composables/use-sensor-status';
import { computed } from 'vue';
import { getDeviceStatusIcon } from '@/constants/device';

const props = withDefaults(defineProps<{
  sensor: qx_Sensor,
  type?: 'icon' | 'label' // smartIconValidator()
}>(), {
  type: 'icon'
});

const { gateway, connection } = useSensorStatus(computed(() => props.sensor))

const label = computed(() => {
  const status = getDeviceStatusIcon(!gateway.value.connectionStatus, connection.value, undefined, undefined)
  return status?.tooltip || ''
})
</script>
